export const COLOR_THEME_PRIMARY = '#114eb8';
export const COLOR_THEME_SECONDARY_FONT_MENU = '#0c50b0';
export const COLOR_THEME_WHITE = '#ffffff';
export const COLOR_FADE_BLACK_PRIMARY = '#595855';
export const COLOR_FADE_BLACK_SECONDARY = '#5c5b59';
export const COLOR_THEME_BLUE_PRIMARY = '#2c4389';
export const COLOR_RED_PRIMARY = '#c22415';